import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUserInfo } from 'Store/userInfo';
import useGetReportOperators from 'Domain/report-attendance/useGetReportOperators';

import Head from 'View/report-attendance/section/head';
import Filter from 'View/report-attendance/section/filter';
import Table from 'View/report-attendance/section/table';
import Tab from 'View/report-attendance/section/tab';

import styles from './styles.module.css';
import ReportAttendanceProvider, { useReportAttendanceState } from './state';
import useGetReportAttendanceHost from 'Domain/report-attendance/useGetReportAttendanceHost';
import { useTranslation } from 'react-i18next';

const ReportAttendance = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('report-attendance');
  const { roleName } = useUserInfo();
  const { filterState, selectedTab } = useReportAttendanceState();

  useEffect(() => {
    if (roleName && roleName !== 'Owner') navigate('/report/attendance/operator');

    /* eslint-disable-next-line */
  }, [roleName]);

  const { data: dataOperators, isFetching: isFetchingOperators } = useGetReportOperators({
    filter: filterState,
    enabled: selectedTab === 'operator',
  });
  const { data: dataHost, isFetching: isFetchingHost } = useGetReportAttendanceHost({
    filter: filterState,
    enabled: selectedTab === 'host',
  });

  const isFetching = selectedTab === 'operator' ? isFetchingOperators : isFetchingHost;
  const data = selectedTab === 'operator' ? dataOperators : dataHost;

  return (
    <Box className={styles['report-attendance__container']}>
      <Head isFetching={isFetching} t={t} />
      <Tab />
      <Filter isFetching={isFetching} t={t} />
      <Table data={data} isFetching={isFetching} t={t} />
    </Box>
  );
};

const ReportAttendanceContainer = () => (
  <ReportAttendanceProvider>
    <ReportAttendance />
  </ReportAttendanceProvider>
);

export default ReportAttendanceContainer;
